import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';

export function BreedCard({ breed }) {
  return (
    <Link
      to={`/dog-breeds/${breed.slug}`}
      className="breed-card block bg-white rounded-3xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] cursor-pointer group"
      data-testid={`breed-card-${breed.slug}`}
    >
      <div className="relative aspect-square overflow-hidden">
        <img
          src={breed.image_url || 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400'}
          alt={breed.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-4">
          <h3 className="font-['Nunito'] font-bold text-white text-lg">{breed.name}</h3>
        </div>
      </div>
      <div className="p-4">
        <div className="flex flex-wrap gap-1.5">
          <Badge className="bg-blue-50 text-[#4A90E2] border-0 rounded-full text-xs font-medium">
            {breed.size}
          </Badge>
          <Badge className="bg-orange-50 text-[#F5A623] border-0 rounded-full text-xs font-medium">
            {breed.energy_level} Energy
          </Badge>
          {breed.compatibility?.hypoallergenic && (
            <Badge className="bg-green-50 text-[#7ED321] border-0 rounded-full text-xs font-medium">
              Hypoallergenic
            </Badge>
          )}
        </div>
        <p className="text-xs text-[#5C636A] mt-2 line-clamp-2">{breed.temperament}</p>
      </div>
    </Link>
  );
}
